import { getStoreId } from "$/hooks/use-store-information"
import { webAuth } from "$/lib/auth"
import { getUiLanguage } from "$/lib/language-preference"

/**
 * For `@Auth`-guarded endpoints. Public endpoints must use publicRequest from
 * public-api.ts instead.
 */
export const { request } = webAuth.createApiClient({
  getStoreId: () => getStoreId(),
  getLanguage: getUiLanguage,
})
